"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Elevation_1 = require("./Elevation");
exports.default = Elevation_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/elevation/lib/index.js
// module id = ./node_modules/@react-mdc/elevation/lib/index.js
// module chunks = 1